import { createStore } from 'vuex';
import homeModule from './modules/home/index.js';
import registerModule from './modules/register/index.js';
import surveyModule from './modules/survey/index.js';
import backofficeModule from './modules/backoffice/index.js';

// create global store
const store = createStore({
  state: {
    // stores the current path the user is on
    previousRoute: null,
  },
  
  mutations: {
    setPreviousRoute(state, route) {
      state.previousRoute = route;
      // set the state to the localStorage in case app is refreshed
      localStorage.setItem('previousRoute', route);
    },
  },

  actions: {
    updatePreviousRoute({ commit }, route) {
      commit('setPreviousRoute', route.path);
    },
  },

  // define modules to keep states for each component of the app
  modules: {
    home: homeModule,
    register: registerModule,
    survey: surveyModule,
    backoffice: backofficeModule,
  },
});

// Load the path the user was on from the local storage if available and commit to state
const savedPreviousRoute = localStorage.getItem('previousRoute');
if (savedPreviousRoute) {
  store.commit('setPreviousRoute', savedPreviousRoute);
}
export default store;